module.exports = __webpack_public_path__ + "static/media/Deer_Stew.578ea0db.png";